(function () {
  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-io-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-io-gallery-thumb]'));
    if (!slides.length) return;

    var prevBtn = root.querySelector('[data-io-gallery-prev]');
    var nextBtn = root.querySelector('[data-io-gallery-next]');
    var viewport = root.querySelector('[data-io-gallery-viewport]');
    var thumbsWrap = root.querySelector('[data-io-gallery-thumbs]');
    var lightbox = root.parentElement.querySelector('[data-io-lightbox]') || document.querySelector('[data-io-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-io-lightbox-image]') : null;
    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    if (index < 0) index = 0;

    function goTo(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('hidden');
        else slide.setAttribute('hidden', '');
      });
      thumbs.forEach(function (thumb, n) {
        var on = n === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && thumbsWrap) {
          var left = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2;
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      });
      if (prevBtn) prevBtn.disabled = slides.length < 2;
      if (nextBtn) nextBtn.disabled = slides.length < 2;
    }

    function goToMediaId(mediaId) {
      if (!mediaId) return;
      var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(mediaId); });
      if (i >= 0) goTo(i);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });

    // Swipe
    var startX = 0, startY = 0, tracking = false;
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) goTo(index + 1);
        else goTo(index - 1);
      }, { passive: true });

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(index - 1);
        if (e.key === 'ArrowRight') goTo(index + 1);
      });
    }

    // Zoom / lightbox
    root.querySelectorAll('[data-io-gallery-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightbox || !lightboxImg) return;
        var full = btn.getAttribute('data-full-src');
        var img = btn.querySelector('img');
        lightboxImg.src = full || (img && img.currentSrc) || (img && img.src) || '';
        lightboxImg.alt = (img && img.alt) || '';
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
    });
    if (lightbox) {
      var close = function () {
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
      };
      var closeBtn = lightbox.querySelector('[data-io-lightbox-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) close();
      });
    }

    // Variant featured media sync (select[name=id])
    var form = root.closest('.io-product-page') && root.closest('.io-product-page').querySelector('form[action*="/cart/add"], form.io-product-form, form');
    if (!form) form = document.querySelector('.io-product-form');
    if (form) {
      var select = form.querySelector('select[name="id"]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (opt && opt.getAttribute('data-media-id')) goToMediaId(opt.getAttribute('data-media-id'));
        });
        var initial = select.options[select.selectedIndex];
        if (initial && initial.getAttribute('data-media-id')) goToMediaId(initial.getAttribute('data-media-id'));
        else goTo(index);
      } else {
        goTo(index);
      }
    } else {
      goTo(index);
    }

    root._ioGoToMediaId = goToMediaId;
  }

  function boot() {
    document.querySelectorAll('[data-io-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
